import React from 'react';
import { useLocation } from 'react-router-dom';

function Biomarkers() {
  const location = useLocation();
  const { hash, pathname } = location;

  return (
    <section>
      <div className="container pt-4 d-flex">
        <div
          className={`tab-pane ${hash === '#Biomarkers' || (!hash && pathname === '/Tools') ? 'active show' : ''}`}
          id="Biomarkers"
        >
          <h1>Biomarker discovery</h1>
          <p className="p-t4">
            Explore genomic and proteomic biomarkers from clinical trials, linked to DISGENET gene-disease
            associations. The biomarkers described in Piñero et al. Comput Struct Biotechnol J. 2023 Mar
            16;21:2110-2118. doi: 10.1016/j.csbj.2023.03.014. PMID: 36968019 have been integrated into
            <a href="https://www.disgenet.com/" target="_blank" rel="noopener noreferrer">
              {' '}
              <u> DISGENET</u>
            </a>
            . Here
            <a
              href="https://www.disgenet.com/search?view=DISEASES&idents=C0028754&source=CLINICALTRIALS&tab=GDA"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              <u>you see an example</u>
            </a>{' '}
            of the biomarkers in clinical trials for Obesity.
          </p>
          <div style={{ paddingBottom: '320px' }}></div>
        </div>
      </div>
    </section>
  );
}

export default Biomarkers;
